import React, { useRef } from 'react';
import { StyleSheet, View } from 'react-native';

import { A } from '@expo/html-elements';

import { BodyText, Image, theme, usePressableState } from '@sg/garnish';

import { getLinkWebAttributes } from '@order/utils';

import { type Props } from '../OrganizationLink.types';

// ─────────────────────────────────────────────────────────────────────────────

export const OrganizationLinkBase = (props: Props) => {
  const { link } = props;

  // ─────────────────────────────────────────────────────────────────────

  const linkRef = useRef(null);
  const linkPressableState = usePressableState(linkRef);

  // ─── Styles ──────────────────────────────────────────────────────────

  const linkHoverStyle = linkPressableState.isHovered ? styles.linkHover : undefined;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.linkWrapper}>
      <A ref={linkRef} href={link.url} accessibilityRole="link" {...getLinkWebAttributes()}>
        <BodyText style={linkHoverStyle} sizeMatch={['16']}>
          {link.label}
        </BodyText>
      </A>

      {link.icon ? (
        <Image
          style={styles.linkIcon}
          aria-label={link.label}
          source={{ uri: link.icon }}
          contentFit="contain"
        />
      ) : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  linkWrapper: {
    minHeight: theme.spacing['6'],
    gap: theme.spacing['2'],
    flexDirection: 'row',
    alignItems: 'center',
  },
  linkHover: {
    textDecorationLine: 'underline',
  },
  linkIcon: {
    width: 32,
    height: 24,
  },
});
